module.exports = __webpack_public_path__ + "img/build.f02181e3.svg";